var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1381.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Show",
    transform: "translate(445.000000, 1381.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.991,21 C12.47,21 9.554,19.643 6.502,16 C8.447,13.678 10.338,12.292 12.364,11.586 C11.525,12.481 11.001,13.676 11.001,15 C11.001,17.761 13.239,20 15.999,20 C18.76,20 20.998,17.761 20.998,15 C20.998,13.69 20.484,12.509 19.66,11.617 C21.663,12.341 23.539,13.737 25.502,16 C22.397,19.579 19.512,21 15.991,21 M15.999,14 C16.552,14 16.999,14.448 16.999,15 C16.999,15.552 16.552,16 15.999,16 C15.448,16 14.999,15.552 14.999,15 C14.999,14.448 15.448,14 15.999,14 M16,0 C7.164,0 0,7.164 0,16 C0,24.837 7.164,32 16,32 C24.836,32 32,24.837 32,16 C32,7.164 24.836,0 16,0",
    id: 179
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionShow);
export default __webpack_public_path__ + "static/media/navigation-and-action-show.0aa9fb8c.svg";
export { ForwardRef as ReactComponent };